import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/Card/Card';
import { Illustration, type IllustrationType } from '@/components/ui/Illustration/Illustration';

interface GenericScreenProps {
  illustration?: IllustrationType;
  title: string;
  description: string;
  leftActionElement?: React.ReactNode;
  rightActionElement?: React.ReactNode;
}

export const GenericSuccessScreen = ({ illustration = 'jumping', title, description, leftActionElement, rightActionElement }: GenericScreenProps) => {
  return (
    <Card className='tablet:w-[460px] desktop:w-[480px] max-tablet:p-5 max-tablet:pb-0 max-tablet:min-h-[calc(100vh-76px)] tablet:h-screen max-h-[684px] w-full'>
      <CardContent className='tablet:mb-6 mb-8 flex flex-1 flex-col items-center justify-center gap-6'>
        <Illustration name={illustration} className='size-[154px]' />
        <CardHeader>
          <CardTitle className='text-heading-m-medium text-center'>{title}</CardTitle>
          {description && <CardDescription className='text-center'>{description}</CardDescription>}
        </CardHeader>
      </CardContent>
      {(!!leftActionElement || !!rightActionElement) && (
        <CardFooter isStickyOnMobile className='flex gap-3 *:w-full'>
          {leftActionElement}
          {rightActionElement}
        </CardFooter>
      )}
    </Card>
  );
};
